import React, {useEffect, useState, useRef} from 'react';
import './Upload.css';
import { IonButton, IonLabel } from '@ionic/react';
import Util from '../services/Util';

const util = new Util();

interface UploadProps {
  inp:any;
  param:any;
  readonly:any;
  memoId:any;
  server:any;
  onChange:any;
  onError:any;
  defaultValue?:any;
  label:any;
}

const Upload: React.FC<UploadProps> = ({ inp, param, readonly, memoId, server, onChange, onError, defaultValue="|||UPLOAD||", label}) => {

  const [state,setState] = useState({
    value: defaultValue,
    fileName: ""
  })
  const [file, setFile] = useState(null);

  const onFileChange = (fileChangeEvent: any) => {
      var f = fileChangeEvent.target.files[0]

      if (param.ext) {
        console.log("ext:"+param.ext);
        var pos = f.name.lastIndexOf(".");
        if (pos>=0) {
          var ext = f.name.substring(pos+1);
          if ((","+param.ext+",").indexOf(","+ext+",")<0) {
            onError({msg:"Invalid File Name Extension : "+f.name+"<br/>Valid Extension : "+param.ext})
            clearFile()
            return;
          }
        } else {
          onError({msg:"Invalid File Name (No Extension) : "+f.name})
          clearFile()
          return;
        }
      }

      f = util.getValidFile(f)

      setFile(f);
  };

  const submitForm = async () => {
    if (!file) {
      return false;
    }

    let formData = new FormData();
    formData.append("id", memoId);
    formData.append(file.name, file);
  
    try {
      const response = await fetch(server.getPrefixUrl()+"memo/file/upload", server.uploadRequest(formData));
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      console.log(response);

      response.json()
      .then(res => {
          console.log("nodeRef:"+res.data[0].nodeRef)
          console.log("path:"+res.data[0].path)
          console.log("name:"+res.data[0].name)
          console.log("desc:"+res.data[0].desc)
          console.log("action:"+res.data[0].action)
          
          const value = "|||UPLOAD|"+res.data[0].name+"|"+(res.data[0].nodeRef ? res.data[0].nodeRef : res.data[0].path);

          setState({value:value, fileName:res.data[0].name})
          onChange({value:value, fileName:res.data[0].name})
      })
    } catch (err) {
      console.log(err);
    }
  };

  const clearFile = () => {
    refUpload.current.value = "";
    setFile(null);
    setState({value:defaultValue,fileName:""})
    onChange({value:defaultValue,fileName:""})
  }

  useEffect(() => {
    //console.log("useEffect()")

    var value = inp.value ? inp.value : defaultValue
    //console.log("   value:"+value)

    var fileName = ""
    if(value.startsWith("|||UPLOAD|")) {
      fileName = value.substring(10);
      const pos = fileName.indexOf("|");
      fileName = fileName.substring(0,pos);
    }

    setState({
      value: value,
      fileName: fileName
    })

  },[])

  useEffect(() => {
    submitForm();
  }, [file]);
  
  const refUpload = useRef(null);
  
  return (
      <div>
          <br/>
          <input ref={refUpload} type="file" onChange={(ev) => onFileChange(ev)} style={{display: "none"}}
          ></input>
        <IonLabel className="ion-text-wrap">
            <span dangerouslySetInnerHTML={{__html: label}}></span>
          <p>{file ? file.name : state.fileName}</p>
        </IonLabel>
          <div>
          <IonButton color="primary" onClick={(e) => {
                            refUpload?.current?.click();
                            console.log('stopProp()');
                            e.stopPropagation()
                          }}>
            Browse...
          </IonButton>
          {file || state.fileName ? (
            <IonButton color="danger" onClick={(e) => {
                              console.log('clearFile()');
                              clearFile()
                              e.stopPropagation()
                            }}>
              Clear
            </IonButton>
          ):""}
          </div>
          <br/>
      </div>
  )
}

export default Upload;
